import EmployeeDeleteModal from 'components/ConfirmModal'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import styles from './RoleDelete.css'

const popoverEmployee = (
  <Popover id='popover-delete-role' title=''>
    <div>
      This role cannot be deleted<br />
      because it has been associated<br />
      with one or several employees.<br />
      Please first unassigned the <br />
      employees and try again.
    </div>
  </Popover>
)

const popoverManager = (
  <Popover id='popover-delete-role' title=''>
    <div>
      Administrator is a special role and <br />
      cannot be deleted by owner,<br />
      because the employee page can only be accessed in this role.<br />
    </div>
  </Popover>
)

class RoleDelete extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      showDeleteModal: false
    }
  }

  render () {
    const {roleDetail} = this.props
    const isDisabled = this._isDeleteButtonDisabled()

    return (
      <span className='pull-left'>
        {isDisabled
        ? <OverlayTrigger trigger={['hover', 'focus']}
          placement='top'
          overlay={roleDetail.level === 2 ? popoverManager : popoverEmployee}
        >
          <div style={{display: 'inline-block', cursor: 'not-allowed'}}>
            <button
              type='button'
              onClick={this._onClickDelete}
              className={`btn btn-danger no-outline ${isDisabled ? styles['btn-disable'] : ''}`}
            >
              <i className='fa fa-trash' />
            </button>
          </div>
        </OverlayTrigger>
        : <button type='button' onClick={this._onClickDelete} className='btn btn-danger no-outline'>
          <i className='fa fa-trash' />
        </button>}
        <EmployeeDeleteModal
          showModal={this.state.showDeleteModal}
          onHide={this._closeDeleteModal}
          title={'Delete Role'}
          description={<span>Are you sure to remove <b>{roleDetail.name}</b> role?</span>}
          onConfirm={this._onConfirmDelete}
          baseColor='danger'
          confirmTitle='Delete'
        />
      </span>
    )
  }

  _isDeleteButtonDisabled = () => {
    const {roleDetail} = this.props
    return roleDetail.employees.length > 0 || roleDetail.level === 2
  }

  _onClickDelete = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({showDeleteModal: true})
  }

  _onConfirmDelete = (e) => {
    this.setState({showDeleteModal: false})
    this.props.onClickDelete(this.props.roleDetail)
  }

  _closeDeleteModal = () => {
    this.setState({showDeleteModal: false})
  }
}

export default RoleDelete



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/RoleDelete/RoleDelete.js